// src/theme/components/link.js
// Semantic token'a dayalı (accent), underline-on-hover, focus-visible ring.

const Link = {
  baseStyle: {
    color: 'linkColor',
    textDecoration: 'none',
    textUnderlineOffset: '3px',
    textDecorationThickness: '1px',
    transitionProperty: 'color, text-decoration-color, box-shadow',
    transitionDuration: 'var(--motion-duration-fast)',
    transitionTimingFunction: 'var(--motion-ease-apple)',
    cursor: 'pointer',
    fontWeight: 'medium',
    _hover: {
      color: 'accentHover',
      textDecoration: 'underline',
    },
    _active: {
      color: 'accentActive',
    },
    _focusVisible: {
      outline: 'none',
      boxShadow: 'focusRing.default',
      borderRadius: 'sm',
    },
  },
  variants: {
    inline: {},
    subtle: {
      color: 'textSecondary',
      fontWeight: 'normal',
      _hover: { color: 'textPrimary', textDecoration: 'underline' },
      _active: { color: 'textPrimary' },
    },
    breadcrumb: {
      color: 'textSecondary',
      fontSize: 'sm',
      fontWeight: 'normal',
      _hover: { color: 'accent', textDecoration: 'underline' },
      '&[aria-current="page"]': {
        color: 'textPrimary',
        fontWeight: 'semibold',
        cursor: 'default',
        textDecoration: 'none',
        _hover: { color: 'textPrimary', textDecoration: 'none' },
      },
    },
    external: {
      color: 'linkColor',
      _hover: { color: 'accentHover', textDecoration: 'underline' },
    },
  },
};

export default Link;
